import {BaseTerms} from "../../../../infrastructure/models/base-terms";

export class AthleteNextGameModuleTerms extends BaseTerms {
  WEB_ATHLETE_NEXT_GAME_HEADER = "#RELEVANT_GAME - #COMPETITION_NAME";
  WEB_ATHLETE_NEXT_GAME_NOT_IN_THE_SQUAD = "Not In Squad";
  WEB_ATHLETE_NEXT_GAME_STATUS_LIVE = "Live";
  WEB_ATHLETE_NEXT_GAME_STATUS_LAST = "Last match";
  WEB_ATHLETE_NEXT_GAME_STATUS_NEXT = "Next match";
}
